import { createFileRoute } from '@tanstack/react-router';

import {
  creditNoteDeletedScreen,
  creditNoteDeletedSearch,
  loadCreditNoteDeletedMessages,
  loadCreditNoteDeletedScreens,
} from '@/modules/credit-note-deleted/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Operações excluídas no caminho do legado (`router.tsx:1311-1316`): o menu passa a apontar para cá quando
// o manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/excluidos/')({
  validateSearch: creditNoteDeletedSearch,
  staticData: { screen: creditNoteDeletedScreen },
  loader: () => loadCreditNoteDeletedMessages(),
  component: lazyScreen(loadCreditNoteDeletedScreens, 'CreditNoteDeletedRouteScreen'),
});
